const datadogHeadesTraceId = "x-datadog-trace-id";

export default function apiMiddleware(handler) {
    return async (req, res) => {
        req?.headers?.origin && res.setHeader("Access-Control-Allow-Origin", req?.headers?.origin);
        res.setHeader("Access-Control-Allow-Headers", datadogHeadesTraceId);

        const headersWithTraceId = {
            "x-datadog-trace-id": req.headers["x-datadog-trace-id"] || null,
            "x-datadog-origin": req.headers["x-datadog-origin"] || null,
            "x-datadog-parent-id": req.headers["x-datadog-parent-id"] || null,
            "x-datadog-sampling-priority": "1",
        } as HeadersInit;
        return handler(req, res, headersWithTraceId);
    };
}
